import { CommonService } from './../../../helpers/common.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, 
  Inject, Input, OnInit, Output,CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { BookingDetails } from '../booking.models';
import { BookingService } from '../booking.service';
import { StarConvertService } from '../../../helpers/star-convertor.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-booking-overview',
  templateUrl: `./booking-overview.component.html`,
  styleUrl: './booking-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush, // Use OnPush strategy
})
export class BookingOverviewComponent implements OnInit {

  @Output() showBookingsData = new EventEmitter<boolean>()
  serviceType?: string = '';
  overViewDetails: BookingDetails | null = null;
  @Input() isLoading: boolean;
  declarationImage: any = [];
  companyId: number = 0;

  constructor(private bookingService: BookingService,
    private starConvertService: StarConvertService,
    private commonService: CommonService, private dialog: MatDialog,
    private cdr: ChangeDetectorRef) {
    this.serviceType = this.overViewDetails?.serviceType
  }

  bookingsGrid() {
    this.showBookingsData.emit(true);
  }

  getStatusClass(statusName: string): string {
    if (!statusName) {
      return '';  
    }
    return this.commonService.getStatusClass(statusName);
  }

  getStatusIcon(statusName: string): string {
    if (!statusName) {
      return '/assets/images/icons-kpi-dashboard/default-icon.png'; // Default icon if status is not available
    }
    return this.commonService.getStatusIcon(statusName);
  }

  ngOnInit(): void {
    const companyIdval = localStorage.getItem('companyId');
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;
    this.bookingService.bookingOverviewDetails.subscribe((overview: BookingDetails | null) => {
      if (overview) {
        const updatedOverview = { ...overview };

        if (updatedOverview.rating <= 0) {
          updatedOverview['starRating'] = 'No rating';
        } else {
          updatedOverview['starRating'] = this.starConvertService.convertDecimalNumberToStars(updatedOverview.rating) + ` <span class="star-rating-value-msg">(${updatedOverview.rating})</span>`
        }
        this.overViewDetails = updatedOverview
        this.isLoading = false
      }

    });
    this.getImagesofDeclaration(this.overViewDetails?.taskId)
  }

  getImagesofDeclaration(imageData: any) {
    imageData = this.overViewDetails?.taskId; 
    this.bookingService.getImagesofDeclaration(imageData, this.companyId).subscribe((details: any[]) => {
      this.declarationImage = details
      this.cdr.detectChanges();
    },
      (error) => {
        return;
        console.error('Error fetching booking details:', error);
      }
    );
  }
  
  openImageDialog(index: number): void {
    this.dialog.open(ImageDialogComponent, {
      width: '80%',
      height: '80%',
      data: {
        images: this.declarationImage,
        currentIndex: index,
      }
    });
  }
}


@Component({
  selector: 'app-image-dialog',
  templateUrl: `./image-dialog.html`,
  styleUrls: ['./booking-overview.component.scss']
})
export class ImageDialogComponent {
  currentIndex: number;
  images: { id: number; path: string }[];

  constructor(
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.images = data.images;
    this.currentIndex = data.currentIndex;
  }

  nextImage(): void {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  previousImage(): void {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }
}